import { getCurrentScope as t, onScopeDispose as e, unref as i } from "vue";
function c(o) {
  return t() ? (e(o), !0) : !1;
}
function d(o) {
  return typeof o == "function" ? o() : i(o);
}
const r = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const a = (o) => o != null, u = Object.prototype.toString, f = (o) => u.call(o) === "[object Object]", p = () => {
}, w = /* @__PURE__ */ l();
function l() {
  var o, n;
  return r && ((o = window == null ? void 0 : window.navigator) == null ? void 0 : o.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
export {
  r as isClient,
  w as isIOS,
  f as isObject,
  p as noop,
  a as notNullish,
  d as toValue,
  c as tryOnScopeDispose
};
//# sourceMappingURL=design-system.es150.js.map
